<template>
    <div id="download">
        <sidebar :content="sidebarData"></sidebar>
        <div id="content">
          <bread :content="breadContent"></bread>
          <p class="Page-title">{{pageTypeCN[this.pageState]}}</p>
          <el-divider></el-divider>
          <div id="card-content">
            <download-card v-for="(item,index) in cardData" :key="index" :cardData="item"></download-card>
          </div>
        </div>
    </div>
</template>
<script>
import sidebar from "@/components/sidebar";
import bread from "@/components/bread";
import downloadCard from '@/components/index/downloadCard'
export default {
  components: {
    sidebar,
    bread,
    downloadCard
  },
  name: "download",
  computed: {
    breadContent(){
      return [
        { text: "首页", routerName: "index" },
        { text: "下载中心", routerName: "download" },
        { text: this.pageTypeCN[this.pageState], routerName: "" },
      ]
    } 
  },
  data() {
    return {
      pageState: 0,
      pageTypeCN: ['学术交流', '应急常识', '在线视频'],
      pageType: ['academic', 'knowledge', 'video'],
      sidebarData: {
        title: "下载中心",
        sub: [
          {
            title: "学术交流",
            sub: [],
            url:'/index/download/academic',
          },
          {
            title: "应急常识",
            sub: [],
            url:'/index/download/knowledge',
          },
          {
            title: "在线视频",
            sub: [],
            url:'/index/download/video',
          },
        ]
      },
      cardData:[]
    };
  },
  methods: {
    changeState(newPageState) {
      this.pageState = newPageState
      this.$router.push({params: {type: this.pageType[newPageState]}})
    },
    async getData() {
      this.pageState = this.pageType.findIndex(item => item === this.$route.params.type)
      if(this.pageState==0){
        this.cardData=(await this.$net.index.getDownloadAcademic());
        this.$store.commit("setHighlightText", "学术交流");
      }
      if(this.pageState==1){
        this.cardData=(await this.$net.index.getDownloadKnowledge());
        this.$store.commit("setHighlightText", "应急常识");
      }
      if(this.pageState==2){
        this.cardData=(await this.$net.index.getDownloadVideo());
        this.$store.commit("setHighlightText", "在线视频");
      }
    }
  },
  async created() {
    this.getData();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'getData',
  },
};
</script>
<style lang="scss" scoped>
#download {
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 40px 0 160px 0;
}
#content{
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#card-content{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.downloadCard{
  width: 45%;
  margin-bottom: 30px;
}
</style>

